// extracted by mini-css-extract-plugin
export default {"address":"style_address__52GMp","address1":"style_address1__B9T4f","address2":"style_address2__Ch1bd","city":"style_city__Wsjg3","zip":"style_zip__V5gPn"};